import React, { useState } from 'react'
import CloseIcon from '@mui/icons-material/Close'
import { toast } from 'react-toastify'
import { uploadLoyaltyRedeemableCsv } from 'api'
import {
  Box,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Typography,
  Button,
  CircularProgress
} from '@mui/material'

import {
  BaseButton,
  StyledDialog,
  StyledIconButton,
  StyledTypography,
  SpinnerWrapper,
} from './styles'

interface UploadCsvModalProps {
  isOpen: boolean
  onClose: () => void
  organizationId: string
}

const UploadCsvModal: React.FC<UploadCsvModalProps> = ({
  isOpen,
  onClose,
  organizationId,
}) => {
  const [file, setFile] = useState<File | null>(null);
  const [loading, setLoading] = useState(false);

  const handleFileChange = (event: any) => {
    const selectedFile = event.target.files?.[0];
    if (selectedFile) {
      setFile(selectedFile);
    }
  };

  const handleUpload = async () => {
    if (!file) return;
    setLoading(true);
    try {
      const res = await uploadLoyaltyRedeemableCsv(organizationId, file);
      if (res.message) {
        toast.success(res.message);
        setLoading(false);
      } else {
        toast.error('Upload failed');
        setLoading(false);
      }
    } catch (err) {
      if (err && typeof err === 'object' && 'response' in err) {
        const response = (err as { response: { data: { errors: string | Array<string> } } }).response;
        if (response?.data?.errors && typeof response.data.errors !== 'string') { 
          toast.error(response.data.errors?.join(' - '));
        } else {
          toast.error('An unknown error occurred during file upload.');
        }
      } else {
        toast.error('An unknown error occurred during file upload.');
      }
    }
    setLoading(false);
  };

  return (
    <StyledDialog open={isOpen} onClose={onClose}>
      <DialogTitle>
        <Box display='flex' justifyContent='space-between' alignItems='center' width='100%'>
          <Typography variant='subtitle2'>Upload CSV</Typography>
          <StyledIconButton edge='end' onClick={onClose} aria-label='close'>
            <CloseIcon />
          </StyledIconButton>
        </Box>
        <span>Upload CSV File</span>
      </DialogTitle>
      <DialogContent>
        <Box mb={2}>
          <FormControl fullWidth required variant='outlined'>
            <StyledTypography>Select File</StyledTypography>
            <Button
              component="label"
              variant="outlined"
              style={{ width: '500px', height: '40px', borderColor: '#D7D7D7' }}
            >
              {file && file.name}
              <input
                type="file"
                accept=".csv"
                hidden
                onChange={handleFileChange}
              />
            </Button>
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions sx={{ padding: '24px' }}>
        <BaseButton noBorder onClick={onClose}>
          Discard
        </BaseButton>
        <BaseButton
          disabled={false}
          variant='solid'
          onClick={handleUpload}
        >
          Upload
        </BaseButton>
      </DialogActions>
      {loading && <SpinnerWrapper><CircularProgress /></SpinnerWrapper>}
    </StyledDialog>
  )
}

export default UploadCsvModal
